module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_location@2x-40db610d2899b80e13d9b9b8877cb37d.webp";